<div class="button-container" *ngIf="isedit">
  <button mat-raised-button class="button" (click)="editPhoto()" *ngIf="isInspector && showEditOrReplace"><i class="material-icons button__icon">edit</i><span>{{'Edit' | translate | async}}</span></button>
  <button mat-raised-button class="button" (click)="fileInput.click()" *ngIf="isInspector && showEditOrReplace"><i class="material-icons button__icon">cloud_upload</i><span>{{'Replace Photo' | translate | async}}</span></button>
  <input style="display: none;" type="file"
       #fileInput accept="image/*"
       (change)="replacePhotoClicked($event)" hidden>
  <button mat-raised-button class="button" (click)="deletePhoto()" *ngIf="isInspector"><i class="material-icons button__icon">delete</i><span>{{'Delete' | translate | async}}</span></button>
</div>
<div class="photo-container">
  <img class="photo-container__photo" [src]="photo" *ngIf="!photoLoading" (click)="openLargeImage(photo)" [@fadeIn]/>
  <div class="center" *ngIf="photoLoading">
    <mat-spinner></mat-spinner>
  </div>
</div>